const logo = '/assets/images/logo.svg';
const logo2 = '/assets/images/logo2.svg';
const electricTower1 = '/assets/images/et-bg.jpg';
const bg = '/assets/images/bg.png';

export { logo, logo2, electricTower1, bg };
